import { render, staticRenderFns } from "./VerDetalleCertificado.vue?vue&type=template&id=ec2aa9ca&scoped=true&"
import script from "./VerDetalleCertificado.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleCertificado.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleCertificado.vue?vue&type=style&index=0&id=ec2aa9ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2aa9ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ec2aa9ca', component.options)
    } else {
      api.reload('ec2aa9ca', component.options)
    }
    module.hot.accept("./VerDetalleCertificado.vue?vue&type=template&id=ec2aa9ca&scoped=true&", function () {
      api.rerender('ec2aa9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadorBHP/VerDetalleCertificado.vue"
export default component.exports